/* tslint:disable */
/* eslint-disable */
/**
 * Vista API
 * Open API definition
 *
 * The version of the OpenAPI document: 1.36.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import { ComparisonResult } from '../../model/vista';
// @ts-ignore
import { ComparisonResultSummary } from '../../model/vista';
/**
 * ComparisonApi - axios parameter creator
 * @export
 */
export const ComparisonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the filter result timeline from the database
         * @summary Returns the timeline of a user filter result
         * @param {string} filterID 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFilterResultsChanges: async (filterID: string, from: number, to: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterID' is not null or undefined
            assertParamExists('findFilterResultsChanges', 'filterID', filterID)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('findFilterResultsChanges', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('findFilterResultsChanges', 'to', to)
            const localVarPath = `/comparison/{filterID}`
                .replace(`{${"filterID"}}`, encodeURIComponent(String(filterID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication security_auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "security_auth", [], configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the filter result timeline from the database
         * @summary Counts number of occurrences of each type of filter comparison
         * @param {string} filterID 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeFilterResultsChanges: async (filterID: string, from: number, to: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterID' is not null or undefined
            assertParamExists('summarizeFilterResultsChanges', 'filterID', filterID)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('summarizeFilterResultsChanges', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('summarizeFilterResultsChanges', 'to', to)
            const localVarPath = `/comparison/{filterID}/summary`
                .replace(`{${"filterID"}}`, encodeURIComponent(String(filterID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication security_auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "security_auth", [], configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparisonApi - functional programming interface
 * @export
 */
export const ComparisonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComparisonApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the filter result timeline from the database
         * @summary Returns the timeline of a user filter result
         * @param {string} filterID 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findFilterResultsChanges(filterID: string, from: number, to: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComparisonResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findFilterResultsChanges(filterID, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonApi.findFilterResultsChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the filter result timeline from the database
         * @summary Counts number of occurrences of each type of filter comparison
         * @param {string} filterID 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summarizeFilterResultsChanges(filterID: string, from: number, to: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonResultSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summarizeFilterResultsChanges(filterID, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonApi.summarizeFilterResultsChanges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComparisonApi - factory interface
 * @export
 */
export const ComparisonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComparisonApiFp(configuration)
    return {
        /**
         * Returns the filter result timeline from the database
         * @summary Returns the timeline of a user filter result
         * @param {string} filterID 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFilterResultsChanges(filterID: string, from: number, to: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ComparisonResult>> {
            return localVarFp.findFilterResultsChanges(filterID, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the filter result timeline from the database
         * @summary Counts number of occurrences of each type of filter comparison
         * @param {string} filterID 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeFilterResultsChanges(filterID: string, from: number, to: number, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonResultSummary> {
            return localVarFp.summarizeFilterResultsChanges(filterID, from, to, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparisonApi - object-oriented interface
 * @export
 * @class ComparisonApi
 * @extends {BaseAPI}
 */
export class ComparisonApi extends BaseAPI {
    /**
     * Returns the filter result timeline from the database
     * @summary Returns the timeline of a user filter result
     * @param {string} filterID 
     * @param {number} from 
     * @param {number} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonApi
     */
    public findFilterResultsChanges(filterID: string, from: number, to: number, options?: RawAxiosRequestConfig) {
        return ComparisonApiFp(this.configuration).findFilterResultsChanges(filterID, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the filter result timeline from the database
     * @summary Counts number of occurrences of each type of filter comparison
     * @param {string} filterID 
     * @param {number} from 
     * @param {number} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComparisonApi
     */
    public summarizeFilterResultsChanges(filterID: string, from: number, to: number, options?: RawAxiosRequestConfig) {
        return ComparisonApiFp(this.configuration).summarizeFilterResultsChanges(filterID, from, to, options).then((request) => request(this.axios, this.basePath));
    }
}

